import paymentsService from '../services/paymentsService';

// Dues Policy
export const fetchCurrentDuesPolicy = async () => {
  const result = await paymentsService.getCurrentDuesPolicy();
  if (!result?.success) {
    const error = new Error(result?.message || 'Aidat politikası alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateDuesPolicy = async (payload) => {
  const result = await paymentsService.updateDuesPolicy(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Aidat politikası güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchAllDuesPolicies = async () => {
  const result = await paymentsService.getAllDuesPolicies();
  if (!result?.success) {
    const error = new Error(result?.message || 'Aidat politikaları alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Dues Management
export const fetchAllDues = async ({ pageNumber = 1, pageSize = 10, status = null, searchTerm = null } = {}) => {
  const result = await paymentsService.getAllDues({ pageNumber, pageSize, status, searchTerm });
  if (!result?.success) {
    const error = new Error(result?.message || 'Aidatlar alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchDuesById = async (id) => {
  const result = await paymentsService.getDuesById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Aidat alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchDuesByMemberId = async (memberId) => {
  const result = await paymentsService.getDuesByMemberId(memberId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Üye aidatları alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchDuesByPeriod = async (period, status = null) => {
  const result = await paymentsService.getDuesByPeriod(period, status);
  if (!result?.success) {
    const error = new Error(result?.message || 'Dönem aidatları alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchUnpaidDuesByPeriod = async (period) => {
  const result = await paymentsService.getUnpaidDuesByPeriod(period);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödenmemiş aidatlar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createMemberDues = async (payload) => {
  const result = await paymentsService.createMemberDues(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Aidat oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const startBulkCreateDues = async (payload) => {
  const result = await paymentsService.startBulkCreateDues(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplu aidat oluşturma başlatılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchBulkCreateDuesStatus = async (jobId) => {
  const result = await paymentsService.getBulkCreateDuesStatus(jobId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplu aidat durumu alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateDues = async (payload) => {
  const result = await paymentsService.updateDues(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Aidat güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteDues = async (id) => {
  const result = await paymentsService.deleteDues(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Aidat silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Payment Operations
export const markAsPaidByAdmin = async (payload) => {
  const result = await paymentsService.markAsPaidByAdmin(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödeme işaretlenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const approvePayment = async (payload) => {
  const result = await paymentsService.approvePayment(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödeme onaylanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const cancelDues = async (payload) => {
  const result = await paymentsService.cancelDues(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Aidat iptal edilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Event Payment Management
export const fetchAllEventPayments = async ({ pageNumber = 1, pageSize = 10, startDate = null, endDate = null, status = null, payerPersonId = null, eventId = null, searchTerm = null } = {}) => {
  const result = await paymentsService.getAllEventPayments({ pageNumber, pageSize, startDate, endDate, status, payerPersonId, eventId, searchTerm });
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik ödemeleri alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchEventPaymentsByEventId = async (eventId, params) => {
  const result = await paymentsService.getEventPaymentsByEventId(eventId, params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik ödemeleri alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchEventPaymentsByPayer = async (payerPersonId, params) => {
  const result = await paymentsService.getEventPaymentsByPayer(payerPersonId, params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Kişi ödemeleri alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchEventPaymentForPayer = async (eventId, payerPersonId) => {
  const result = await paymentsService.getEventPaymentForPayer(eventId, payerPersonId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödeme detayı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const cancelEventPayment = async (payload) => {
  const result = await paymentsService.cancelEventPayment(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödeme iptal edilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const markEventPaymentAsPaid = async (payload) => {
  const result = await paymentsService.markEventPaymentAsPaid(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödeme işaretlenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const approveEventPayment = async (payload) => {
  const result = await paymentsService.approveEventPayment(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödeme onaylanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchEventSummaries = async ({ pageNumber = 1, pageSize = 10, startDate = null, endDate = null, status = null, searchTerm = null } = {}) => {
  const result = await paymentsService.getEventSummaries({ pageNumber, pageSize, startDate, endDate, status, searchTerm });
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik özetleri alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchEventPaymentsWithGuests = async (eventId) => {
  const result = await paymentsService.getEventPaymentsWithGuests(eventId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik ödemeleri alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Project Donation Management
export const fetchAllProjectDonations = async (params = {}) => {
  const result = await paymentsService.getAllProjectDonations(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje bağışları alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchProjectDonationById = async (id) => {
  const result = await paymentsService.getProjectDonationById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje bağışı detayı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const searchProjectDonations = async (payload) => {
  const result = await paymentsService.searchProjectDonations(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje bağışları aranamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const createProjectDonationByAdmin = async (payload) => {
  const result = await paymentsService.createProjectDonationByAdmin(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje bağışı oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const approveProjectDonationPayment = async (payload) => {
  const result = await paymentsService.approveProjectDonationPayment(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje bağışı ödemesi onaylanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const cancelProjectDonation = async (payload) => {
  const result = await paymentsService.cancelProjectDonation(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje bağışı iptal edilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchProjectDonationStatistics = async (params = {}) => {
  const result = await paymentsService.getProjectDonationStatistics(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje bağışı istatistikleri alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchProjectDonationSummaryByProject = async (params = {}) => {
  const result = await paymentsService.getProjectDonationSummaryByProject(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje bağışı özetleri alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Product Management
export const fetchAllProducts = async (params = {}) => {
  const result = await paymentsService.getAllProducts(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ürünler alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchProductById = async (id) => {
  const result = await paymentsService.getProductById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ürün detayı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchProductLogoDefaults = async () => {
  const result = await paymentsService.getProductLogoDefaults();
  if (!result?.success) {
    const error = new Error(result?.message || 'Logo varsayılanları alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createProduct = async (payload) => {
  const result = await paymentsService.createProduct(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ürün oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateProduct = async (payload) => {
  const result = await paymentsService.updateProduct(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ürün güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteProduct = async (id) => {
  const result = await paymentsService.deleteProduct(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ürün silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateProductStock = async (payload) => {
  const result = await paymentsService.updateProductStock(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Stok güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const setProductStock = async (payload) => {
  const result = await paymentsService.setProductStock(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Stok miktarı ayarlanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const reorderProducts = async (items) => {
  const result = await paymentsService.reorderProducts(items);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ürün sıralaması güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const uploadProductImage = async ({ productId, file }) => {
  const result = await paymentsService.uploadProductImage({ productId, file });
  if (!result?.success) {
    const error = new Error(result?.message || 'Ürün görseli güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Product Order Management (ürün siparişleri / satışları)
export const fetchAllProductOrders = async (params = {}) => {
  const result = await paymentsService.getAllProductOrders(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ürün siparişleri alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data ?? [], meta: result.metaData };
};

export const fetchProductOrderById = async (id) => {
  const result = await paymentsService.getProductOrderById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Sipariş detayı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createProductOrder = async (payload) => {
  const result = await paymentsService.createProductOrder(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Sipariş oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const cancelProductOrder = async (payload) => {
  const result = await paymentsService.cancelProductOrder(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Sipariş iptal edilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const payForGuestOrHost = async (payload) => {
  const result = await paymentsService.payForGuestOrHost(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödeme yapılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const payForSelectedGuests = async (payload) => {
  const result = await paymentsService.payForSelectedGuests(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödemeler yapılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Donation Card Management
export const fetchCurrentDonationCard = async () => {
  const result = await paymentsService.getCurrentDonationCard();
  if (!result?.success) {
    const error = new Error(result?.message || 'Bağış kartı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchDonationCardById = async (id) => {
  const result = await paymentsService.getDonationCardById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bağış kartı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchDonationCardLogoDefaults = async () => {
  const result = await paymentsService.getDonationCardLogoDefaults();
  if (!result?.success) {
    const error = new Error(result?.message || 'Logo varsayılanları alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Bağış kartı oluşturma (görselli)
export const createDonationCard = async (payload) => {
  const result = await paymentsService.createDonationCard(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bağış kartı oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Bağış kartı güncelleme (metinsel alanlar)
export const updateDonationCard = async (payload) => {
  const result = await paymentsService.updateDonationCard(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bağış kartı güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Bağış kartı görselini güncelleme
export const uploadDonationCardImage = async ({ cardId, file }) => {
  const result = await paymentsService.uploadDonationCardImage({ cardId, file });
  if (!result?.success) {
    const error = new Error(result?.message || 'Bağış kartı görseli güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Donation Card Purchase Management
export const fetchAllDonationCardPurchases = async ({ pageNumber = 1, pageSize = 10, status = null, purchasedByPersonId = null, donatedToPersonId = null, searchTerm = null } = {}) => {
  const result = await paymentsService.getAllDonationCardPurchases({ pageNumber, pageSize, status, purchasedByPersonId, donatedToPersonId, searchTerm });
  if (!result?.success) {
    const error = new Error(result?.message || 'Bağış kartı satın alımları alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchDonationCardPurchaseById = async (id) => {
  const result = await paymentsService.getDonationCardPurchaseById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Satın alım detayı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchDonationCardPurchasesByPurchasedBy = async (personId, type) => {
  const result = await paymentsService.getDonationCardPurchasesByPurchasedBy(personId, type);
  if (!result?.success) {
    const error = new Error(result?.message || 'Satın alımlar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchDonationCardPurchasesByDonatedTo = async (personId, type) => {
  const result = await paymentsService.getDonationCardPurchasesByDonatedTo(personId, type);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bağışlar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const approveDonationCardPayment = async (payload) => {
  const result = await paymentsService.approveDonationCardPayment(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Ödeme onaylanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const cancelDonationCardPurchase = async (payload) => {
  const result = await paymentsService.cancelDonationCardPurchase(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Satın alım iptal edilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createDonationCardPurchase = async (payload) => {
  const result = await paymentsService.createDonationCardPurchase(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bağış kartı satın alımı oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const searchDonationCardPurchases = async (payload) => {
  const result = await paymentsService.searchDonationCardPurchases(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Arama yapılamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchTopDonors = async ({ topCount = 10, startDate = null, endDate = null } = {}) => {
  const result = await paymentsService.getTopDonors({ topCount, startDate, endDate });
  if (!result?.success) {
    const error = new Error(result?.message || 'En çok bağış yapanlar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchTopRecipients = async ({ topCount = 10, startDate = null, endDate = null } = {}) => {
  const result = await paymentsService.getTopRecipients({ topCount, startDate, endDate });
  if (!result?.success) {
    const error = new Error(result?.message || 'En çok bağış alanlar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchDonationCardPurchasesByMemberIdPurchased = async (memberId, { pageNumber = 1, pageSize = 10 } = {}) => {
  const result = await paymentsService.getDonationCardPurchasesByMemberIdPurchased(memberId, { pageNumber, pageSize });
  if (!result?.success) {
    const error = new Error(result?.message || 'Satın alımlar alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchDonationCardPurchasesByMemberIdDonatedTo = async (memberId, { pageNumber = 1, pageSize = 10 } = {}) => {
  const result = await paymentsService.getDonationCardPurchasesByMemberIdDonatedTo(memberId, { pageNumber, pageSize });
  if (!result?.success) {
    const error = new Error(result?.message || 'Bağışlar alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchDonationStatistics = async ({ startDate = null, endDate = null } = {}) => {
  const result = await paymentsService.getDonationStatistics({ startDate, endDate });
  if (!result?.success) {
    const error = new Error(result?.message || 'İstatistikler alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchCurrentDuesPolicy,
  updateDuesPolicy,
  fetchAllDuesPolicies,
  fetchAllDues,
  fetchDuesById,
  fetchDuesByMemberId,
  fetchDuesByPeriod,
  fetchUnpaidDuesByPeriod,
  createMemberDues,
  startBulkCreateDues,
  fetchBulkCreateDuesStatus,
  updateDues,
  deleteDues,
  markAsPaidByAdmin,
  approvePayment,
  cancelDues,
  fetchAllEventPayments,
  fetchEventPaymentsByEventId,
  fetchEventPaymentsByPayer,
  fetchEventPaymentForPayer,
  cancelEventPayment,
  markEventPaymentAsPaid,
  approveEventPayment,
  fetchEventSummaries,
  fetchEventPaymentsWithGuests,
  payForGuestOrHost,
  payForSelectedGuests,
  fetchCurrentDonationCard,
  fetchDonationCardById,
  updateDonationCard,
  fetchAllDonationCardPurchases,
  fetchDonationCardPurchaseById,
  fetchDonationCardPurchasesByPurchasedBy,
  fetchDonationCardPurchasesByDonatedTo,
  fetchDonationCardPurchasesByMemberIdPurchased,
  fetchDonationCardPurchasesByMemberIdDonatedTo,
  approveDonationCardPayment,
  cancelDonationCardPurchase,
  createDonationCardPurchase,
  searchDonationCardPurchases,
  fetchTopDonors,
  fetchTopRecipients,
  fetchDonationStatistics,
};
